/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `lesson` - Lesson
* `class` - Class
* `rental` - Rental
 */
export type ServiceTypeEnum = typeof ServiceTypeEnum[keyof typeof ServiceTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceTypeEnum = {
  lesson: 'lesson',
  class: 'class',
  rental: 'rental',
} as const;
